// App.js
import {
  createBrowserRouter,
  RouterProvider,
  Outlet,
  createRoutesFromElements,
  Route,
  ScrollRestoration,
  Navigate,
  useParams,
  useLocation,
} from "react-router-dom"; 
import Footer from "./Components/Footer/Footer";
import Home from "../src/Pages/Home/Home";
import { ToastContainer } from "react-toastify";
import Contact from "./Pages/Contact/Contact";
import { FloatingWhatsApp } from "react-floating-whatsapp"; 
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { I18nextProvider } from 'react-i18next';
import i18n from './Components/i18n/i18n';
import { avatar } from "./assets/images";
import Header from "./Components/Header/Header";
import About from "./Pages/About/About";
import Qhse from "./Pages/Qhse/Qhse";

// Oil Gas Solutions

import Services from "./Pages/OilGasSolutions/Services/Services";
import Supply from "./Pages/OilGasSolutions/Supply/Supply";

import IpmIsm from "./Pages/OilGasSolutions/Services/IPM-ISM/IpmIsm";
import Geological from "./Pages/OilGasSolutions/Services/Geological/Geological";
import Resato from "./Pages/OilGasSolutions/Services/Resato/Resato";
import Directional from "./Pages/OilGasSolutions/Services/Directional/Directional";
import Drillbits from "./Pages/OilGasSolutions/Services/DrillBits/Drillbits";
import Reaming from "./Pages/OilGasSolutions/Services/Reaming/Reaming";
import Coring from "./Pages/OilGasSolutions/Services/Coring/Coring";
import Upper from "./Pages/OilGasSolutions/Services/Upper/Upper";

import Fiber from "./Pages/OilGasSolutions/Supply/Fiber/Fiber";
import Liner from "./Pages/OilGasSolutions/Supply/Liner/Liner";
import Whipstocks from "./Pages/OilGasSolutions/Supply/Whipstocks/Whipstocks";
import Corebit from "./Pages/OilGasSolutions/Supply/Corebit/Corebit";
import Hydro from "./Pages/OilGasSolutions/Supply/Hydro/Hydro";
import Gas from "./Pages/OilGasSolutions/Supply/Gas/Gas";
import Pressure from "./Pages/OilGasSolutions/Supply/Pressure/Pressure";
import DrillbitsSupply from "./Pages/OilGasSolutions/Supply/DrillBits/Drillbits";
import DirectionalSupply from "./Pages/OilGasSolutions/Supply/Directional/Directional";
import ResatoSupply from "./Pages/OilGasSolutions/Supply/Resato/Resato";
import PumpsCompressors from "./Pages/IndustrialSolutions/Supply/PumpsCompressors/PumpsCompressors";
import GlovesHelmets from "./Pages/IndustrialSolutions/Supply/GlovesHelmets/GlovesHelmets";
import HandTools from "./Pages/IndustrialSolutions/Supply/HandTools/HandTools";
import Consultancy from "./Pages/IndustrialSolutions/Services/Consultancy/Consultancy";
import Training from "./Pages/IndustrialSolutions/Services/TrainingTechnicalSupport/Training";
import Maintenance from "./Pages/IndustrialSolutions/Services/MaintenanceRepair/Maintenance";
import Insulation from "./Pages/IndustrialSolutions/Services/IndustrialInsulation/Insulation";
import IndustrialServices from "./Pages/IndustrialSolutions/Services/IndustrialServices";
import IndustrialSupply from "./Pages/IndustrialSolutions/Supply/IndustrialSupply";

const LanguageWrapper = ({ children }) => {
  const { i18n } = useTranslation();
  const { lang } = useParams();
  const location = useLocation(); // Əlavə edildi

  useEffect(() => { 
    const changeLanguage = async () => {
      if (["az", "en", "ru"].includes(lang)) {
        await i18n.changeLanguage(lang);
      } else {
        await i18n.changeLanguage("en"); 
      }
    };
    
    changeLanguage();
  }, [lang, location.pathname]); // Yalnız lang və pathname'i izlə

  return children;
};
const Layout = () => {
  return (
    <div>
      <ToastContainer position="top-right" autoClose={1000} theme="colored" />
      <Header/>  
      <Outlet />
      <Footer />
    </div>
  );
};

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route>
      <Route path="/" element={<Navigate to="/en" replace />} />
      
      <Route path="/:lang" element={
        <LanguageWrapper>
          <Layout />
        </LanguageWrapper>
      }>
        <Route index element={<Home />} />
        <Route path="about" element={<About />} />
        <Route path="qhse" element={<Qhse />} />
        <Route path="contact" element={<Contact />} />

         {/* Oil Gas Solutions */}
        <Route path="services" element={<Services />} />
        <Route path="supply" element={<Supply />} />

        <Route path="services/ipm" element={<IpmIsm />} />
        <Route path="services/geological" element={<Geological />} />
        <Route path="services/resato" element={<Resato />} />
        <Route path="services/directional" element={<Directional />} />
        <Route path="services/drillbits" element={<Drillbits />} />
        <Route path="services/reaming" element={<Reaming />} />
        <Route path="services/coring" element={<Coring />} />
        <Route path="services/upper" element={<Upper />} />

        <Route path="supply/drillbits" element={<DrillbitsSupply />} />
        <Route path="supply/directional" element={<DirectionalSupply />} />
        <Route path="supply/fiber" element={<Fiber />} />
        <Route path="supply/liner" element={<Liner />} />
        <Route path="supply/whipstock" element={<Whipstocks />} />
        <Route path="supply/corebit" element={<Corebit />} />
        <Route path="supply/resato" element={<ResatoSupply />} />
        <Route path="supply/hydro" element={<Hydro />} />
        <Route path="supply/gas" element={<Gas />} /> 
        <Route path="supply/pressure" element={<Pressure />} />


 
        {/* Industrial Solutions */}
        <Route path="industrial/services" element={<IndustrialServices />} />
        <Route path="industrial/supply" element={<IndustrialSupply />} />

        <Route path="industrial/services/consultancy" element={<Consultancy />} />
        <Route path="industrial/services/industrial" element={<Insulation />} /> 
        <Route path="industrial/services/maintenance" element={<Maintenance />} />
        <Route path="industrial/services/training" element={<Training />} />

        <Route path="industrial/supply/gloves" element={<GlovesHelmets />} />
        <Route path="industrial/supply/hand-tools" element={<HandTools />} />
        <Route path="industrial/supply/pumps-compressor" element={<PumpsCompressors />} />
      </Route>   
    </Route> 
  ) 
);

function App() {
  
 
  return (
    <div className="font-secondFont">
      <I18nextProvider i18n={i18n}>
      <RouterProvider router={router}>
        <ScrollRestoration />
      </RouterProvider>
      {/* Digər elementlər */}
    </I18nextProvider>

    <FloatingWhatsApp
          phoneNumber="+994503378805"
          accountName="Caspian Rock Solutions"
          chatMessage="Salam, sizə necə kömək edə bilərik?"
          placeholder="Mesaj yazın..."
          avatar= {avatar}
          messageDelay="1"
        />
    </div>
  );
}
 
export default App;